import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

// const MonthC = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const KeyRegisterAllotDist_data = async (params) => {

    const response = await fetch(`${process.env.REACT_APP_URL_SALE}/StockRegister/getStock_register`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const Stock_FPS = ({ month, year, comm_id, dist_code, afso_code, heading, AfsoName }) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    const [renderContentt, setRenderContentt] = useState(null);
    const detailsRRef = useRef(null); // Use ref to scroll to this div

    useEffect(() => {

        const getData = async () => {
            try {

                const response_data = await KeyRegisterAllotDist_data({ month, year, comm_id, dist_code, afso_code });
                setTabHeading(response_data.heading);

                if (response_data.data && response_data.data.length > 0) {
                    setReportData(response_data.data);

                } else {
                    setReportData("No data found ");
                }
            } catch (error) {
                setError(error);
                console.log(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [month, year, comm_id, dist_code, afso_code]);
    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && detailsRRef.current) {
            detailsRRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [loading, error, reportData]);

    if (loading) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Box sx={{ display: 'flex' }}>
            <CircularProgress />
        </Box></div>
    }

    if (error) {
        return <div className="mainhead" align="center">
            Internal Error
        </div>
    }

    if (reportData.length === 0) {
        return <div className="mainhead" align="center">
            No data found
        </div>
    }

    const totals = reportData.reduce(
        (acc, item) => {
            acc.allotted_qty += parseFloat(item.allotted_qty) || 0;
            acc.ob += parseFloat(item.ob) || 0;
            acc.prevMonth += parseFloat(item.prevMonth) || 0;
            acc.onorc_sale_past_month += parseFloat(item.onorc_sale_past_month) || 0;
            acc.pds_sale_past_month += parseFloat(item.pds_sale_past_month) || 0;
            acc.curntMonth += parseFloat(item.curntMonth) || 0;
            acc.onorc_sale_current_month += parseFloat(item.onorc_sale_current_month) || 0;
            acc.pds_sale_current_month += parseFloat(item.pds_sale_current_month) || 0;
            acc.futrMonth += parseFloat(item.futrMonth) || 0;
            acc.pds_sale_future_month += parseFloat(item.pds_sale_future_month) || 0;
            acc.onorc_sale_past_month += parseFloat(item.onorc_sale_past_month) || 0;
            acc.received_qty += parseFloat(item.received_qty) || 0;
            acc.extra_ro += parseFloat(item.extra_ro) || 0;
            acc.sixi_case += parseFloat(item.sixi_case) || 0;
            acc.issued_qty += parseFloat(item.issued_qty) || 0;
            acc.onorc_sale_issued_qty += parseFloat(item.onorc_sale_issued_qty) || 0;
            acc.pds_sale_issued_qty += parseFloat(item.pds_sale_issued_qty) || 0;
            acc.cb += parseFloat(item.cb) || 0;
            return acc;
        },
        {
            allotted_qty: 0,
            ob: 0,
            prevMonth: 0,
            onorc_sale_past_month: 0,
            pds_sale_past_month: 0,
            curntMonth: 0,
            onorc_sale_current_month: 0,
            pds_sale_current_month: 0,
            futrMonth: 0,
            onorc_sale_future_month: 0,
            pds_sale_future_month: 0,
            received_qty: 0,
            extra_ro: 0,
            sixi_case: 0,
            issued_qty: 0,
            onorc_sale_issued_qty: 0,
            pds_sale_issued_qty: 0,
            cb: 0,


        }
    );
    return (

        <>

            <table align="center" width="90%" border={1}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={16}>{tabHeading}(Office: {AfsoName || "N/A"})</th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan={4}>Sl.No</th>
                        <th rowSpan={4}>FPS</th>
                        <th rowSpan={4}>Dealer</th>
                        <th rowSpan={4}>Alloted Qty<br />(Kgs)</th>
                        <th rowSpan={4}>OB Qty<br />(Kgs)</th>
                        <th colSpan={8}>Received Qty<br />(Kgs)</th>
                        <th colSpan={2}>Issued Qty<br />(Kgs)</th>
                        <th rowSpan={4}>CB Qty<br />(Kgs)</th>
                    </tr>
                    <tr className="tableheader">
                        <th colSpan={7}> Regular<br /><span className="styleDF"></span></th>
                        {/* <th rowSpan={3}>Extra<br /> <span className="styleDF"></span> </th> */}
                        <th rowSpan={3}> Moved<br /> <span className="styleDF"></span></th>
                        <th rowSpan={3}>Pds Issued Qty<br />(Kgs)</th>
                        <th rowSpan={3}>ONRC Issued Qty<br />(Kgs)</th>
                    </tr>


                    <tr className="tableheader">
                        <th colSpan={2}>Previous Month</th>
                        <th colSpan={2}>Current Month</th>
                        <th colSpan={2}>Future Month</th>
                        <th rowSpan={2}>Total</th>
                    </tr>

                    <tr className="tableheader">
                        <th> Pds Previous Month</th>
                        <th>ONRC Previous Month</th>

                        <th>Pds Current Month</th>
                        <th>ONRC Current Month</th>

                        <th>Pds Future Month</th>
                        <th>ONRC Future Month</th>

                    </tr>
                </thead>
                <tbody>
                    {
                        reportData.map((item, index) => (

                            <tr key={item.dist_code}>
                                <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                <td style={{ textAlign: 'left' }}> {item.fps_id} </td>
                                <td style={{ textAlign: 'left' }} >{item.del_name || 'NA'}</td>
                                <td style={{ textAlign: 'right' }} >{item.allotted_qty}</td>
                                <td style={{ textAlign: 'right' }} >{item.ob}</td>
                                <td style={{ textAlign: 'right' }}> {Number(item.pds_sale_past_month || 0).toFixed(2)}</td>
                                <td style={{ textAlign: 'right' }}> {Number(item.onorc_sale_past_month || 0).toFixed(2)}</td>
                                <td style={{ textAlign: 'right' }}>{Number(item.pds_sale_current_month || 0).toFixed(2)}</td>
                                <td style={{ textAlign: 'right' }}>{Number(item.onorc_sale_current_month || 0).toFixed(2)}</td>
                                <td style={{ textAlign: 'right' }}>{Number(item.pds_sale_future_month || 0).toFixed(2)}</td>
                                <td style={{ textAlign: 'right' }}>{Number(item.onorc_sale_future_month || 0).toFixed(2)}</td>
                                <td style={{ textAlign: 'right' }}>{Number(item.received_qty).toFixed(2)}</td>
                                {/* <td style={{ textAlign: 'right' }}  >{item.extra_ro}</td> */}
                                <td style={{ textAlign: 'right' }} >{item.sixi_case}</td>
                                <td style={{ textAlign: 'right' }} >{item.pds_sale_issued_qty || 0}</td>
                                <td style={{ textAlign: 'right' }} >{item.onorc_sale_issued_qty || 0}</td>

                                <td style={{ textAlign: 'right' }}  >{item.cb}</td>

                            </tr>
                        ))
                    }
                    <tr className="tableheader">
                        <td colSpan={3} style={{ textAlign: 'right', fontWeight: 'bold' }}>Total:</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.allotted_qty.toFixed(2)}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.ob.toFixed(2)}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.pds_sale_past_month.toFixed(2)}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.onorc_sale_past_month.toFixed(2)}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.pds_sale_current_month.toFixed(2)}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.onorc_sale_current_month.toFixed(2)}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.pds_sale_future_month.toFixed(2)}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.onorc_sale_future_month.toFixed(2)}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.received_qty.toFixed(2)}</td>
                        {/* <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.extra_ro.toFixed(2)}</td> */}
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.sixi_case.toFixed(2)}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.pds_sale_issued_qty.toFixed(2)}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.onorc_sale_issued_qty.toFixed(2)}</td>
                        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.cb.toFixed(2)}</td>
                    </tr>
                </tbody>
            </table>

            <br /><br />
            <br /><br />
        </>
    );
};

export default Stock_FPS;
